<template>
    <!--<input type="text" v-model="cpf" pattern="[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}" v-bind="$attrs" />-->
    <input type="text" v-model="cpf"  v-bind="$attrs" />
</template>
<script>

import format from '/plugins/cpf-cnpj-email';

export default {
    props: ['value'],
    data() {
        const Cpf = format(this.value);
        return {
            Cpf: ''
        }
    },
    computed: {
        cpf: {
            get() {
                return this.Cpf;
            },
            set(value) {
                //this.Cpf = null;
                var cpf = format(value);                
                //this.Cpf = cpf;           
                this.Cpf = 'xxx';
                this.Cpf = cpf;
                this.$emit('input', cpf);
            }
        }
    },
    watch: {
        value: {
            handler(value) {
                this.Cpf = format(value);                
            },
            immediate: true
        }
    }
}
</script>